import { formatPrice } from '@printtat/shared';
import { Button } from '@printtat/ui';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

interface CartSummaryProps {
  subtotal: number;
  itemCount: number;
  onClose?: () => void;
  disabled?: boolean;
}

export const CartSummary = ({ subtotal, itemCount, onClose, disabled }: CartSummaryProps) => {
  const navigate = useNavigate();

  const handleCheckout = () => {
    onClose?.();
    navigate('/checkout');
  };

  return (
    <div className="border-t border-gray-200 pt-4 space-y-3">
      <div className="flex justify-between text-sm">
        <span className="text-gray-500">Subtotal ({itemCount} items)</span>
        <span className="font-semibold text-gray-900">{formatPrice(subtotal)}</span>
      </div>
      <p className="text-[11px] text-gray-400">Shipping calculated at checkout</p>

      <Button
        color="dark"
        className="w-full"
        onClick={handleCheckout}
        disabled={disabled}
      >
        Checkout
        <ArrowRight size={14} />
      </Button>
    </div>
  );
};
